module.exports = __webpack_public_path__ + "media/images/profile-ba76fcd925a7fc7206c035eeaf0e672f.svg";